import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const Reveal = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal. Pass an array of lines.
export const MaskLines = ({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.12,
  animate = false,
}) => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "110%" },
    show: { y: "0%", transition: { duration: 1, ease: EASE } },
  };
  const trigger = animate
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, margin: "-80px" } };
  return (
    <motion.div className={className} variants={container} initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <motion.span className={`block ${lineClassName}`} variants={child}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.div>
  );
};

export { EASE };
